import { render, staticRenderFns } from "./pharmacyArticle.vue?vue&type=template&id=f42693d2&"
var script = {}
import style0 from "./pharmacyArticle.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f42693d2')) {
      api.createRecord('f42693d2', component.options)
    } else {
      api.reload('f42693d2', component.options)
    }
    module.hot.accept("./pharmacyArticle.vue?vue&type=template&id=f42693d2&", function () {
      api.rerender('f42693d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pharmacyArticle/pharmacyArticle.vue"
export default component.exports